import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private spinnerRef: OverlayRef;

  constructor(private overlay: Overlay) {}

  private cdkSpinnerCreate() {
    return this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'app-backdrop',
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
    });
  }

  show() {
    if (this.spinnerRef) {
      this.spinnerRef.detach();
    }
    this.spinnerRef = this.cdkSpinnerCreate();
    this.spinnerRef.attach(new ComponentPortal(MatProgressSpinner));
  }

  hide() {
    if (this.spinnerRef?.hasAttached()) {
      this.spinnerRef.detach();
    }
  }
}
